/**
 * Step3 Component: electricityConsumption
 */

import React, { Component, Fragment } from 'react';

import appStore from '../../../redux/store/appStore';
import { updateGui, updateConfiguration } from '../../../redux/actions/actions';

import Step from './Step';

import { nextPermissionDeniedGuiFeedback } from '../../../helpers/wizard-helper';
import { floatStringFormat } from '../../../helpers/currency-helper';

import './Step3.css';

import { getItem } from '../../../helpers/object-helper';

const stepNum = 3;
const editingDataId = 'configuration.electricityConsumption';
const costToConsumptionRatio = .24;

class Step3 extends Component {

    constructor(props) {
        super(props);
        this.editingDataId = editingDataId;
        this.isValidated = this.isValidated.bind(this);
        this.onCostInput = this.onCostInput.bind(this);
        this.onConsumptionInput = this.onConsumptionInput.bind(this);
    }

    componentDidMount() {

        appStore.dispatch(updateGui({
            currentEditingData: editingDataId
        }));

        // autofill cost if already set in application store
        this.updateCostGuiFromStore();

        // autofill consumption if already set in application store
        this.updateConsumptionGuiFromStore();

    }

    isValidated(showWarnMessage) {
        const data = getItem(editingDataId, appStore.getState());
        const valid = (data !== null);
        if (!valid && showWarnMessage === undefined) {
            nextPermissionDeniedGuiFeedback(this, stepNum, true);
        }
        return (data !== null);
    }

    /**
     * Updates electricityConsumption in application store
     * @param {Number} consumption
     */
    updateStore(consumption) {
        appStore.dispatch(updateConfiguration({
            electricityConsumption: consumption
        }));
    }

    /**
     * Updates electricityConsumptionCost in application store
     * @param {Number} cost
     */
    updateStoreCost(cost) {
        appStore.dispatch(updateConfiguration({
            electricityConsumptionCost: cost
        }));
    }

    /**
     * Event listener for cost input event
     * @param {Event} evt
     */
    onCostInput(evt) {
        let cost = parseInt(evt.target.value);
        if (isNaN(cost)) {
            cost = null;
        }
        this.updateStoreCost(cost);
        this.updateConsumptionValue();
    }

    /**
     * Event listener for consumption input event
     * @param {Event} evt
     */
    onConsumptionInput(evt) {
        let consumption = parseInt(evt.target.value);
        if (isNaN(consumption)) {
            consumption = null;
        }
        this.updateStore(consumption);
        this.updateCostValue(this.consumptionToCost(consumption));
    }

    /**
     * Updates cost value
     *  - in gui
     *  - in application store
     * @param {Number} icost 
     */
    updateCostValue(icost = null) {
        this.updateCostGui(icost);
        this.updateStoreCost(icost);
    }

    /**
     * Updates cost gui
     * @param {Number} icost 
     */
    updateCostGui(icost) {
        const value = (icost) ? floatStringFormat(icost.toString()) : '' ;
        document.querySelector('.slc-electricityConsumption-question-cost input').value = value;
    }

    /**
     * Updates cost gui with application store value
     */
    updateCostGuiFromStore() {
        const cost = getItem('configuration.electricityConsumptionCost', appStore.getState());
        this.updateCostGui(cost);
    }

    updateConsumptionValue(icost = null) {
        const cost = (icost) ? icost : parseInt(document.querySelector('.slc-electricityConsumption-question-cost input').value);
        const consumption = (!isNaN(cost)) ? this.costToConsumption(cost) : null;
        this.updateConsumptionGui(consumption);
        this.updateStore(consumption);
    }

    /**
     * Updates consumption gui
     * @param {Number} consumption 
     */
    updateConsumptionGui(consumption) {
        const value = (consumption) ? floatStringFormat(consumption.toString()) : '' ;
        document.querySelector('.slc-electricityConsumption-question-consumption input').value = value;
    }

    /**
     * Updates consumption gui with application store value
     */
    updateConsumptionGuiFromStore() {
        const consumption = getItem('configuration.electricityConsumption', appStore.getState());
        this.updateConsumptionGui(consumption);
    }

    consumptionToCost(consumption) {
        return (consumption) ? consumption * costToConsumptionRatio : null;
    }

    costToConsumption(cost) {
        return cost / costToConsumptionRatio;
    }

    /**
     * Returns the JSX body for this Step<N> Component
     * The body is passed as a prop to the Step Component, which is actually rendered
     */
    body() {
        return (
            <Fragment>
                <div className="slc-electricityConsumption">
                    {this.bodyGetQuestions()}
                </div>
            </Fragment>
        );
    }

    bodyGetQuestions() {
        return (
            <div className="slc-electricityConsumption-questions">
                <div className="slc-form-input-text-widget slc-form-input-text-widget--with-infos slc-electricityConsumption-question slc-electricityConsumption-question-cost">
                    <div className="slc-form-input-text-widget__label">
                    Qual è l’importo della tua ultima bolletta elettrica?
                    </div>
                    <div className="slc-form-input-text-widget__input-container">
                        <input type="text" className="slc-form-input-text-widget__input" onInput={this.onCostInput}></input>
                        <div className="slc-form-input-text-widget__input-measure-unit">&euro;</div>
                        <div className="slc-form-input-text-widget__input-infos">(bimestrale)</div>
                    </div>
                </div>
                <div className="slc-form-input-text-widget slc-electricityConsumption-question slc-electricityConsumption-question-consumption">
                    <div className="slc-form-input-text-widget__label">
                    Oppure indicaci quanti kWh?
                    </div>
                    <div className="slc-form-input-text-widget__input-container">
                        <input type="text" className="slc-form-input-text-widget__input" onInput={this.onConsumptionInput}></input>
                        <div className="slc-form-input-text-widget__input-measure-unit">kWh/anno</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return <Step stepComponent={this} stepNum={stepNum} stepBody={this.body()} />;
    }
    
}

export default Step3;